import { onMounted, onBeforeUnmount } from 'vue'

export const SESSION_CHANNEL = 'auth'

export const SESSION_EVENTS = {
  UPDATED: 'session-updated',
  LOGOUT: 'session-logout',
}

/**
 * Publish session event to other tabs via BroadcastChannel
 * @param {string} type
 * @param {object} [payload]
 */
export function publishSessionEvent(type, payload = {}) {
  try {
    const channel = new BroadcastChannel(SESSION_CHANNEL)
    channel.postMessage({ type, ts: Date.now(), ...payload })
    channel.close()
  } catch (e) {
    console.error(e)
  }
}

export function publishSessionUpdated(payload) {
  publishSessionEvent(SESSION_EVENTS.UPDATED, payload)
}

export function publishSessionLogout(payload) {
  publishSessionEvent(SESSION_EVENTS.LOGOUT, payload)
}

/**
 * Subscribe to session events
 * @param {(type: string, payload: any) => void} onEvent
 */
export function useSessionBroadcastListener(onEvent) {
  let bc = null

  onMounted(() => {
    try {
      bc = new BroadcastChannel(SESSION_CHANNEL)
      bc.onmessage = (event) => {
        const data = event?.data || {}
        onEvent?.(data.type, data)
      }
    } catch (e) {
      console.error(e)
    }
  })

  onBeforeUnmount(() => {
    try {
      bc?.close()
      bc = null
    } catch (e) {
      console.error(e)
    }
  })
}
